<p (click)="loadAllData()"><a><small><i class="fa fa-refresh"></i> Refresh Dropdowns</small> </a> </p>
